import { Component } from '@angular/core';
import { SwitchCode } from './switch-code';

@Component({
	selector: 'common-questions-section',
	template: require('./common-questions-section.component.html'),
})
export class CommonQuestionsSectionComponent {
	isCorporate: boolean = false;

	public items: SwitchCode[] = [
		{ name: 'Ιδιώτες', code: 0, userType: 'Retail' },
		{ name: 'Επιχειρήσεις', code: 1, userType: 'Corporate' },
	];

	toggleCorporate(bool: number): void {
		if (bool === 1) {
		  this.isCorporate = true;
		} else {
		  this.isCorporate = false;
		}
	  }

}
